import { render, staticRenderFns } from "./DashboardCardUnreconciled.vue?vue&type=template&id=2438128f&scoped=true&"
import script from "./DashboardCardUnreconciled.vue?vue&type=script&lang=js&"
export * from "./DashboardCardUnreconciled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438128f",
  null
  
)

export default component.exports